import React from 'react';
import { Brain, Sparkles } from "lucide-react";
import { useDesignSystem, cn } from '../designSystem';

const LoadingSpinner = () => {
  const { colors, typography, effects } = useDesignSystem();
  
  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
      <div className={cn(
        effects.glassmorphism,
        "p-12 rounded-2xl shadow-2xl max-w-md text-center"
      )}>
        <div className="mb-6 flex items-center justify-center">
          <Brain className={cn("w-12 h-12 text-blue-500", effects.pulse)} />
          <Sparkles className={cn("w-6 h-6 text-blue-300", effects.bounce)} />
        </div>
        <h3 className={cn(
          typography.h2,
          typography.gradient,
          "bg-[length:200%_auto]",
          effects.gradient,
          "mb-3"
        )}>
          Skribo jobber på saken
        </h3>
        <p className={cn(typography.body, "text-lg")}>
          Analyserer og sammenfatter notatet ditt...
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;